// @ts-nocheck
import React, { useEffect, useReducer, useRef, ReactElement  } from "react";
import { Module } from './module.js';
import { TechnologySelector } from './technology.selector.js';
import { TagsSelector } from './tags.selector.js';
import { ListSelector } from './list.selector.js';
import {FilterBlock} from './filter.block.js';
import {FilterTitle} from './filter.title.js';
import { ReportsSuggestions } from '../reports/reports.requests.js';

// Interface for filter item
interface FilterItem {
	module: string;
	title?: string;
	value?: wts_ignore_any;
	[key: string]: wts_ignore_any;
}

// Interface for module item
interface ModuleItem {
	title: string;
	description?: string;
	elem: ReactElement;
	value?: FilterItem[];
}

// Interface for state
interface FiltersSelectorState {
	list: ModuleItem[];
	selected: { [key: string]: boolean };
	suggested: {
		regions: wts_ignore_any[];
		domains: wts_ignore_any[];
		languages: wts_ignore_any[];
	};
}

// Interface for component props
interface FiltersSelectorProps {
	iteration?: number;
	list?: FilterItem[];
	selected?: boolean;
	focus?: string;
	onCancel: () => void;
	onApply: (data: wts_ignore_any) => void;
}

const ModulesDefault = function( state: FiltersSelectorState, dispatch: React.Dispatch<[string, wts_ignore_any]>, iteration?: number, list?: FilterItem[] ): ModuleItem[] {

	let table: { [key: string]: FilterItem[] } = {};

	if( !Array.isArray( list ) )
		list = [];

	for( let item of list ){

		if( !table[ item.module ] )
			table[ item.module ] = [];

		table[ item.module ].push( item );

	};

	return [
		{
			title: "Technology",
			elem: <TechnologySelector
				iteration={ iteration }
				list={ table[ "Technology" ] }
				query={ "technology" }
				// techBorder={true}
				version
				template={{ title: "LongName", value: "Technology", icon: "Icon" }}
				vtemplate={{ title: "Version", value: "Version", icon: "Icon" }}
				icon
				onChange={( value ) => dispatch([ "value", { key: "Technology", value: value } ]) }
			/>
		},
		{
			title: "Category",
			elem: <TechnologySelector
				iteration={ iteration }
				list={ table[ "Category" ] }
				query={ "category" }
				template={{ title: "LongName", value: "Category", icon: "Icon" }}
				icon={ "mdi" }
				onChange={( value ) => dispatch([ "value", { key: "Category", value: value } ]) }
			/>
		},
		{
			title: "Header",
			elem: <TechnologySelector
				//subhead={false}
				iteration={ iteration }
				list={ table[ "Header" ] }
				query={ "header" }
				template={{ title: "Header", value: "Header", icon: "Icon" }}
				onChange={( value ) => dispatch([ "value", { key: "Header", value: value } ]) }
			/>
		},
		{
			title: "Top Level Domains (TLD)",
			description: "The  top-level domain is the last part of the domain name.\n" +
				"\t\t\t\t\tFor example, in the domain name www.example.com, the top-level domain is com",
			elem: <TagsSelector
				suggested={ state.suggested[ "domains" ] }
				type={ "domains" }
				possible={ state.suggested[ "domains" ] }
				iteration={ iteration }
				list={ table[ "Top Level Domains (TLD)" ] }
				onChange={( value ) => dispatch([ "value", { key: "Top Level Domains (TLD)", value: value } ]) }
			/>
		},
		{
			title: "Regions",
			description: "Filter selection by one or many world regions",
			elem: <ListSelector
				suggested={ state.suggested[ "regions" ] }
				type={ "regions" }
				iteration={ iteration }
				list={ table[ "Regions" ] as wts_ignore_any }
				onChange={( value ) => dispatch([ "value", { key: "Regions", value: value } ]) }
			/>
		},
		{
			title: "Languages",
			description: "Filter by language that was detected on the root page of the website",
			elem: <TagsSelector
				suggested={ state.suggested[ "languages" ] }
				type={ "languages" }
				possible={ state.suggested[ "languages" ] }
				iteration={ iteration }
				list={ table[ "Languages" ] }
				onChange={( value ) => dispatch([ "value", { key: "Languages", value: value } ]) }
			/>
		},
	];
};
const ModulesIteration = function( modules: ModuleItem[] ): { [key: string]: FilterItem[] } {

	let table: { [key: string]: FilterItem[] } = [];

	for( let item of modules ){

		if( !item.value )
			continue;

		table[ item.title ] = [];

		for( let s of item.value ){
			table[ item.title ].push({ ...s, ["module"]: item.title });
		};

	};

	return table;
};
const closeAllModules = ( key: string, modules: ModuleItem[] ): { [key: string]: boolean } => {

	let table: { [key: string]: boolean } = {};

	for( let item of modules ){

		if( !item.value )
			continue;

		table[ item.title ] = item.title === key ? true : false;

	};

	return table;
};
const FiltersSelectorReducer = function( state: FiltersSelectorState, [ type, data ]: [string, wts_ignore_any] ): FiltersSelectorState {

	if( type === "value" ){

		let list = [ ...state.list ];
		let f = list.findIndex(( item ) => item.title === data.key );

		if( f > -1 ){
			list[ f ].value = data.value;
		};

		return {
			...state,
			list: list
		};
	}else if( type === "selected" ){
		return {
			...state,
			selected: data
		};
	}else if( type === "suggested" ){

		if( !state.suggested[ data.type ] )
			return;

		const suggested = data.list || [];

		return {
			...state,
			suggested: { ...state.suggested, [ data.type ]: suggested }
		};
	}else if( type === "list" ){
		return {
			...state,
			list: [ ...data ]
		};
	};

	return state;
};

export const FiltersSelector = ( props: FiltersSelectorProps ) => {

	const [ state, dispatch ] = useReducer( FiltersSelectorReducer, {
		list: [],
		selected: {},
		suggested: {
			regions: [],
			domains: [],
			languages: []
		}
	});

	useEffect(() => {

		ReportsSuggestions({
			query: "region",
			type: "regions",
			template: { title: "LongName", value: "Id", list: "Countries" }
		}, dispatch );

		ReportsSuggestions({
			query: "language",
			type: "languages",
			template: { title: "Language", value: "Id", count: "DomainCount" }
		}, dispatch );

		ReportsSuggestions({
			query: "tld",
			type: "domains",
			template: { title: "TLD", value: "TLD", count: "DomainCount" }
		}, dispatch );

	}, []);

	useEffect(() => {
		dispatch([ "list", ModulesDefault( state, dispatch, props.iteration, props.list ) ]);
	}, [ props.iteration, state.suggested ]);

	return(
		<div className={"f-selector" + (props.selected ? "" : " hidden")}>
			<div className={ "f-selector-bg" } onClick={ props.onCancel }>{}</div>

			{
				state.list.map(( item: ModuleItem ) => {
					return (
					<Module
						title={ item.title }
						description={ item.description }
						key={ item.title }
						hidden={ props.focus ? props.focus !== item.title : false}
						focused={ !!props.focus }
						selected={ state.selected[ item.title ] }
						onChange={() => {
							dispatch([ "selected", closeAllModules( item.title, state.list ) ]);
						}}
					>{
						item.elem
					}
					</Module>
					)
				})
			}

			<div className={"f-selector-btn" }>
				<p className={"f-selector-btn-apply confirm"} onClick={() => {
					props.onApply( ModulesIteration( state.list ) );
				}}>Apply</p>
				<p className={"f-selector-btn-cancel alert"} onClick={ props.onCancel }>Cancel</p>
			</div>

		</div>
	);
};